/* fk-shop.js — Foreva Kaash storefront: overlays (menu + cart drawer), cart, "Complete the fit", card galleries + quick add.
   Port of the approved mockup (site_rebuild/mockups/fk-mockup.js). Cart state is /cart.js's shape; the first paint
   comes from the drawer's [data-fk-cart] JSON, every change goes through /cart/add.js and /cart/change.js. */
(function () {
  var FK = window.FK = {};
  var $ = FK.$ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = FK.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;
  var catalog = FK.catalog = JSON.parse($('[data-fk-catalog]').textContent);   // snippets/fk-catalog-json.liquid
  var SIZE_NAMES = FK.SIZE_NAMES = { S: 'Small', M: 'Medium', L: 'Large', XL: 'X-Large', '2XL': 'XX-Large', '3XL': '3X-Large' };
  // a product with no size option has one variant called "Default Title" (Liquid: product.has_only_default_variant)
  var oneSize = FK.oneSize = function (p) { return p.sizes.length === 1 && p.sizes[0] === 'Default Title'; };
  var money = FK.money = function (cents) { var d = cents / 100; return '$' + (d % 1 ? d.toFixed(2) : d); };
  var esc = FK.esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var url = FK.url = function (h) { return catalog[h] ? catalog[h].url : '/products/' + encodeURIComponent(h); };
  var canBuy = FK.canBuy = function (h) { return !!(catalog[h] && catalog[h].available); };

  /* typewriter label swap (Pythia retypes its button label ~35ms per character) */
  FK.type = function (el, text) {
    if (el.textContent === text) return;
    clearInterval(el._fkType);
    var i = 0; el.textContent = '';
    el._fkType = setInterval(function () { el.textContent = text.slice(0, ++i); if (i >= text.length) clearInterval(el._fkType); }, 35);
  };

  /* ---------------- overlays: menu + cart share one scrim; Esc closes the top one ---------------- */
  var scrim = $('[data-fk-scrim]'), stack = [];
  function syncOverlays() { var on = stack.length > 0; scrim.toggleAttribute('data-open', on); html.classList.toggle('fk-locked', on); }
  function overlay(el, opener) {
    var o = {
      open: function () {
        stack.slice().forEach(function (x) { if (x !== o) x.close(true); });
        el.setAttribute('data-open', ''); stack.push(o); syncOverlays();
        if (opener) opener.setAttribute('aria-expanded', 'true');
        var f = $('[data-fk-close]', el); if (f) f.focus({ preventScroll: true });
      },
      close: function (silent) {
        if (!el.hasAttribute('data-open')) return;
        el.removeAttribute('data-open'); stack = stack.filter(function (x) { return x !== o; }); syncOverlays();
        if (opener) { opener.setAttribute('aria-expanded', 'false'); if (!silent) opener.focus({ preventScroll: true }); }
      },
      isOpen: function () { return el.hasAttribute('data-open'); }
    };
    $$('[data-fk-close]', el).forEach(function (b) { b.addEventListener('click', function () { o.close(); }); });
    return o;
  }
  scrim.addEventListener('click', function () { stack.slice().reverse().forEach(function (o) { o.close(); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && stack.length) stack[stack.length - 1].close(); });
  var menuBtn = $('[data-fk-menu-open]'), menu = overlay($('[data-fk-menu]'), menuBtn);
  menuBtn.addEventListener('click', function () { menu.open(); });

  /* ---------------- header: big logo at the top, slim bar once scrolled (--fk-p 0..1, see fk-base.css) ---------------- */
  var chrome = $('.fk-chrome-section');
  if (chrome) {
    var hdrRange = 1, hdrTick = false;
    var measureHdr = function () { var cs = getComputedStyle(chrome); hdrRange = Math.max(1, Number(cs.getPropertyValue('--fk-hdr-row')) - Number(cs.getPropertyValue('--fk-hdr-band'))); };
    var syncHdr = function () { hdrTick = false; var p = Math.min(1, Math.max(0, -chrome.getBoundingClientRect().top / hdrRange)); chrome.style.setProperty('--fk-p', p.toFixed(3)); };
    window.addEventListener('scroll', function () { if (!hdrTick) { hdrTick = true; requestAnimationFrame(syncHdr); } }, { passive: true });
    window.addEventListener('resize', function () { measureHdr(); syncHdr(); });
    measureHdr(); syncHdr();
  }

  /* ---------------- cart ---------------- */
  var drawerEl = $('[data-fk-drawer]'), drawer = overlay(drawerEl, null);
  /* /cart.js -> the line shape the drawer renders (variant_title null when the product has no size option) */
  function sized(src, w) { return src ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; }
  function normalize(c) {
    return { items: (c.items || []).map(function (it) {
      return { key: it.key, id: it.id, handle: it.handle, product_title: it.product_title,
        variant_title: it.product_has_only_default_variant ? null : it.variant_title,
        final_price: it.final_price, image: sized(it.image, 200), url: it.url, quantity: it.quantity };
    }) };
  }
  var cart = { items: [] };
  try { cart = normalize(JSON.parse($('[data-fk-cart]', drawerEl).textContent)); } catch (e) {}
  var lineState = {}, notice = null, pending = [], newKey = null;   // pending: placeholder lines for adds still in flight (one per add)
  var freeShip = Number(drawerEl.getAttribute('data-fk-free-ship-cents')) || 0;   // FK cart drawer setting; 0 hides the bar

  function totals(c) {
    c.item_count = c.items.reduce(function (n, it) { return n + it.quantity; }, 0);
    c.total_price = c.items.reduce(function (n, it) { return n + it.final_price * it.quantity; }, 0);
    return c;
  }
  function save() {}
  totals(cart);

  /* network: one request at a time, so a fast double tap can't race itself. Each call resolves to the new cart. */
  var queue = Promise.resolve();
  function serial(fn) { var run = queue.then(fn, fn); queue = run.catch(function () {}); return run; }
  function post(path, body) {
    return fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart error'); return j; }); });
  }
  function fresh() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }); }
  var api = {
    add: function (item) { return serial(function () {
      return post('/cart/add.js', { items: [{ id: item.id, quantity: 1 }] }).then(fresh).then(function (c) { return totals(normalize(c)); });
    }); },
    change: function (key, qty) { return serial(function () {
      return post('/cart/change.js', { id: key, quantity: qty }).then(function (c) { return totals(normalize(c)); });
    }); }
  };

  function itemFor(handle, size) {
    var p = catalog[handle];
    return { id: p.variants[size], handle: handle, product_title: p.title, variant_title: oneSize(p) ? null : size, final_price: p.price * 100, image: p.images[0], url: url(handle) };
  }

  function lineHTML(it) {
    var st = lineState[it.key] || {};
    return '<li class="' + (st.loading ? 'is-loading' : '') + (it.key === newKey ? ' is-new' : '') + '" data-key="' + esc(it.key) + '">' +
      '<a class="fk-line__img" href="' + esc(it.url) + '"><img src="' + esc(it.image) + '" alt="" width="88" height="88" loading="lazy"></a>' +
      '<div><p class="fk-line__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
        '<p class="fk-line__price">' + money(it.final_price * it.quantity) + '</p>' +
        (it.variant_title ? '<p class="fk-line__variant">Size ' + esc(it.variant_title) + '</p>' : '') +
        '<div class="fk-qty"><button type="button" data-fk-qty="-1" aria-label="Decrease quantity">&minus;</button><output aria-label="Quantity">' + it.quantity + '</output><button type="button" data-fk-qty="1" aria-label="Increase quantity">+</button></div></div>' +
      '<button type="button" class="fk-line__rm" data-fk-rm aria-label="Remove ' + esc(it.product_title) + '">Remove</button>' +
      (st.error ? '<p class="fk-line__error" role="alert">Couldn\'t update this item. <button type="button" data-fk-retry>Try again</button></p>' : '') +
    '</li>';
  }

  /* Complete the fit: what goes with the pieces already in the cart first ("Goes with your …"), then the rest of the
     drop that isn't in the cart. Ports: pairs from a product metafield (custom.pairs, product list) — no app needed. */
  var fitKey = null;
  function renderFit(items, count) {
    var inCartHandles = items.map(function (it) { return it.handle; });
    var picks = [], why = {}, mySize = {};
    function ok(h) { return canBuy(h) && inCartHandles.indexOf(h) < 0 && picks.indexOf(h) < 0; }   // in-stock pieces only (B-033)
    items.forEach(function (it) { var c = catalog[it.handle]; if (!c) return; (c.pairs || []).forEach(function (h) { if (ok(h)) { picks.push(h); why[h] = c.short || c.title; mySize[h] = it.variant_title; } }); });
    Object.keys(catalog).forEach(function (h) { if (ok(h)) picks.push(h); });
    picks = count ? picks.slice(0, 6) : picks.slice(0, 4);
    var key = picks.map(function (h) { return h + ':' + (why[h] || '') + ':' + (mySize[h] || ''); }).join('|') + '#' + count;   // tags are part of the key, or a settled add keeps stale tags
    var box = $('[data-fk-fit]', drawerEl);
    box.hidden = !picks.length;
    if (key === fitKey) return;
    fitKey = key;
    $('h3', box).textContent = count ? 'Complete the fit' : 'Shop the drop';
    $('[data-fk-fit-row]', box).innerHTML = picks.map(function (h) {
      var p = catalog[h];
      var pre = (mySize[h] || '').toUpperCase();
      return '<li class="fk-fit__card"><a class="fk-fit__img" href="' + url(h) + '"><img src="' + esc(p.images[0]) + '" alt="" width="400" height="320" loading="lazy"></a>' +
        (why[h] ? '<p class="fk-fit__tag">Goes with your ' + esc(why[h]) + '</p>' : '') +
        '<p class="fk-fit__name"><a href="' + url(h) + '">' + esc(p.title) + '</a></p><p class="fk-fit__price">' + money(p.price * 100) + '</p>' +
        '<form class="fk-fit__form" action="/cart/add" method="post" data-fk-add data-handle="' + esc(h) + '">' +
          (oneSize(p) ? '<input type="hidden" name="id" value="' + p.variants['Default Title'] + '" data-size="Default Title">'
            : '<select name="id" aria-label="Size for ' + esc(p.title) + '"><option value="">Size</option>' + p.sizes.map(function (s) {
                var on = p.avail[s] !== false;
                return '<option value="' + p.variants[s] + '" data-size="' + esc(s) + '"' + (on && s.toUpperCase() === pre ? ' selected' : '') + (on ? '' : ' disabled') + '>' + esc(s) + (on ? '' : ' - sold out') + '</option>'; }).join('') + '</select>') +
          '<button type="submit" class="fk-fit__add">Add</button>' +
        '</form></li>';
    }).join('');
    $('[data-fk-fit-row]', box).scrollLeft = 0;
    syncFitNav();
  }
  /* drawer carousel arrows (a mouse can't swipe) */
  var fitRow = $('[data-fk-fit-row]', drawerEl), fitPrev = $('[data-fk-fit-prev]', drawerEl), fitNext = $('[data-fk-fit-next]', drawerEl);
  function syncFitNav() { fitPrev.disabled = fitRow.scrollLeft < 4; fitNext.disabled = fitRow.scrollLeft + fitRow.clientWidth > fitRow.scrollWidth - 4; }
  function stepFit(d) { var c = fitRow.querySelector('li'); if (c) fitRow.scrollBy({ left: d * (c.getBoundingClientRect().width + 8), behavior: 'smooth' }); }
  fitPrev.addEventListener('click', function () { stepFit(-1); }); fitNext.addEventListener('click', function () { stepFit(1); });
  fitRow.addEventListener('scroll', function () { requestAnimationFrame(syncFitNav); }, { passive: true });

  function render() {
    var items = pending.concat(cart.items);
    var count = items.reduce(function (n, it) { return n + it.quantity; }, 0);
    var subtotal = items.reduce(function (n, it) { return n + it.final_price * it.quantity; }, 0);   // optimistic: includes the line in flight
    drawerEl.setAttribute('data-state', count ? 'filled' : 'empty');
    $('[data-fk-lines]', drawerEl).innerHTML = items.map(lineHTML).join('');
    $('[data-fk-empty]', drawerEl).hidden = count > 0;
    $('[data-fk-drawer-count]', drawerEl).textContent = count || '';
    $('[data-fk-subtotal]', drawerEl).textContent = money(subtotal);
    var n = $('[data-fk-notice]', drawerEl);
    n.hidden = !notice;
    if (notice) n.innerHTML = esc(notice.text) + ' <button type="button" data-fk-notice-retry>Try again</button>';
    var ship = $('[data-fk-ship]', drawerEl);
    ship.hidden = !freeShip;
    if (freeShip) {
      var left = freeShip - subtotal;
      $('[data-fk-ship-text]', ship).textContent = left > 0 ? money(left) + ' away from free shipping' : 'Free shipping unlocked';
      $('[data-fk-ship-fill]', ship).style.transform = 'scaleX(' + Math.min(1, subtotal / freeShip) + ')';
    }
    renderFit(items, count);
    $$('[data-fk-cart-count]').forEach(function (c) {
      var was = c.textContent; c.textContent = count || '';
      if (String(count || '') !== was && count) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      c.parentNode.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
    newKey = null;
  }

  /* optimistic add: the drawer opens at once with the line greyed, the real cart replaces it on success */
  function add(item) {
    notice = null;
    var existing = cart.items.filter(function (x) { return x.id === item.id; })[0];
    var ph = null;
    if (existing) lineState[existing.key] = { loading: true };
    else { ph = Object.assign({ quantity: 1 }, item, { key: 'pending-' + Date.now() + Math.random() }); pending.push(ph); lineState[ph.key] = { loading: true }; }
    render();
    if (!drawer.isOpen()) drawer.open();
    return api.add(item).then(function (next) {
      settle(ph, existing);   // clear BEFORE the paint that reads it
      if (!existing) { var hit = next.items.filter(function (x) { return x.id === item.id; })[0]; newKey = hit ? hit.key : null; }
      cart = next; save(); render();
      $('[data-fk-cart-status]').textContent = item.product_title + (item.variant_title ? ', size ' + item.variant_title : '') + ', added to cart';
      return true;
    }).catch(function (err) {
      settle(ph, existing);
      var why = err && /sold out|not available|unavailable/i.test(err.message) ? ' It just sold out.' : '';
      notice = { text: 'Couldn\'t add ' + item.product_title + (item.variant_title ? ' (' + item.variant_title + ')' : '') + '.' + why, retry: function () { add(item); } };
      render();
      throw new Error('add failed');   // callers (PDP button) must not report success
    });
  }
  function settle(ph, existing) {
    if (ph) { pending = pending.filter(function (x) { return x !== ph; }); delete lineState[ph.key]; }
    if (existing) delete lineState[existing.key];
  }
  function change(key, qty) {
    notice = null; lineState[key] = { loading: true }; render();
    api.change(key, qty).then(function (next) { delete lineState[key]; cart = next; save(); render(); })
      .catch(function () { lineState[key] = { error: true, retryQty: qty }; render(); });
  }
  FK.cart = { add: function (handle, size) { return add(itemFor(handle, size)); }, open: function () { drawer.open(); } };

  $('[data-fk-lines]', drawerEl).addEventListener('click', function (e) {
    var li = e.target.closest('li[data-key]'); if (!li) return;
    var key = li.getAttribute('data-key'), it = cart.items.filter(function (x) { return x.key === key; })[0]; if (!it) return;
    var q = e.target.closest('[data-fk-qty]');
    if (q) change(key, Math.max(0, it.quantity + Number(q.getAttribute('data-fk-qty'))));
    else if (e.target.closest('[data-fk-rm]')) change(key, 0);
    else if (e.target.closest('[data-fk-retry]')) change(key, lineState[key].retryQty);
  });
  $('[data-fk-notice]', drawerEl).addEventListener('click', function (e) { if (e.target.closest('[data-fk-notice-retry]') && notice) notice.retry(); });
  $$('[data-fk-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); drawer.open(); }); });

  /* any [data-fk-add] form (card chips, phone size lists, drawer suggestions, PDP rows) adds handle + clicked size.
     Every add button also carries its variant id (name="id"), so without JS the form posts to /cart/add as is. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-fk-add]'); if (!f || !catalog[f.getAttribute('data-handle')]) return;
    e.preventDefault();
    var size = e.submitter && e.submitter.getAttribute('data-size'), sel = $('select[name="id"]', f), one = $('input[name="id"]', f);
    if (!size && sel) {
      if (!sel.value) { sel.classList.remove('is-nudge'); void sel.offsetWidth; sel.classList.add('is-nudge'); sel.focus(); try { sel.showPicker(); } catch (err) {} return; }
      size = sel.selectedOptions[0].getAttribute('data-size');
    }
    if (!size && one) size = one.getAttribute('data-size');
    if (!size) return;
    closeDropdowns();
    FK.cart.add(f.getAttribute('data-handle'), size).catch(function () {});
  });

  /* ---------------- dropdown size lists (phone cards, PDP Complete the fit) ---------------- */
  function closeDropdowns(except) { $$('.fk-dd.is-open').forEach(function (d) { if (d !== except) { d.classList.remove('is-open'); $('.fk-dd__btn', d).setAttribute('aria-expanded', 'false'); } }); }
  FK.closeDropdowns = closeDropdowns;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fk-dd__btn');
    if (b && b.type !== 'submit') { var d = b.closest('.fk-dd'), open = !d.classList.contains('is-open'); closeDropdowns(d); d.classList.toggle('is-open', open); b.setAttribute('aria-expanded', String(open)); return; }
    if (!e.target.closest('.fk-dd')) closeDropdowns();
  });

  /* ---------------- product cards (home + collections): markup is snippets/fk-card.liquid; this only enhances ---------------- */
  FK.enhanceCards = function (root) {
    $$('img', root).forEach(function (img) { if (img.complete && img.naturalWidth) img.classList.add('is-loaded'); else img.addEventListener('load', function () { img.classList.add('is-loaded'); }); });
    $$('[data-fk-gal]', root).forEach(function (gal) {
      var track = $('.fk-gal__track', gal), segs = $$('.fk-gal__segs i', gal), prev = $('.fk-gal__arrow--prev', gal), next = $('.fk-gal__arrow--next', gal);
      if (!segs.length) return;
      var sync = function () { var i = Math.round(track.scrollLeft / track.clientWidth); segs.forEach(function (s, n) { s.classList.toggle('is-on', n === i); }); prev.disabled = i === 0; next.disabled = i === segs.length - 1; };
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      var x0 = 0, moved = false;   // a swipe must not also follow the product link
      track.addEventListener('pointerdown', function (e) { x0 = e.clientX; moved = false; });
      track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - x0) > 8) moved = true; });
      track.addEventListener('click', function (e) { if (moved) e.preventDefault(); }, true);
    });
  };

  render();
  $$('[data-fk-grid]').forEach(FK.enhanceCards);
})();
